/**
 * Where a lost aircraft came down.
 *
 * Every input can be overridden, because the worst case — an aircraft that went
 * fully dark before it was ever tracked — is exactly when a commander needs the
 * estimate most, and then the last position comes off a paper log rather than
 * the live snapshot.
 */

import { api, type ApiResult } from '@/api/client';
import type { ImpactResult } from '@/stores/impactStore';

export type ImpactCause = 'unknown' | 'comms-lost' | 'shot-down' | 'impact';

export interface ImpactRequest {
  cause: ImpactCause;
  windSpeedMs?: number;
  windFromDeg?: number;
  failsafeIsRtl?: boolean;
  rangeRemainingM?: number;
  /** Monte Carlo falls to simulate for the heat map. 0 returns rings only. */
  samples?: number;
  lastKnown?: {
    lat?: number;
    lon?: number;
    altM?: number;
    headingDeg?: number;
    groundSpeedMs?: number;
    kind?: string;
    homeLat?: number;
    homeLon?: number;
  };
}

export function estimateImpact(
  droneId: string,
  body: ImpactRequest,
): Promise<ApiResult<ImpactResult>> {
  return api.post<ImpactResult>(`/impact/${encodeURIComponent(droneId)}`, body, {
    logged: false,
  });
}
